
import request from '@/utils/http/request'


export async function store({ barcode }) {
    return await request.post('/barcodestore', { barcode: barcode }, {
        noAuth: false
    });
}

export async function fetch({ barcode }) {
    return await request.post('/barcodefetch', { barcode: barcode  }, {
        noAuth: false
    });
}
